import React from "react";

import Menu from "./global/Menu";
import LangSwitcher from "./global/LangSwitcher";
import UserMenu from "./global/UserMenu";

export const Header = ({translations, location}) => {
	return (
		<header className="header pt-20 pt-md-30 position-fixed start-0 end-0 top-0 z-3 pe-none" data-header>
			<div className="container px-xl-32">
				<div className="row justify-content-between align-items-center">
					<div className="col-2 align-self-center">
            <LangSwitcher translations={translations} />
					</div>
					<div className="col-10 d-flex justify-content-end">
            {/*<UserMenu location={location}/>*/}
            <Menu location="DESKTOP_NAV" />
					</div>
				</div>
			</div>
		</header>
	);
};
